var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row-min-space"},[_c('b-form-group',{attrs:{"id":"input-group-1","label":_vm.field.label,"label-for":"input-1"}},[_c('div',{staticClass:"row profile-setup"},[_c('div',{staticClass:"col-md-5 mb-20 dialling-code-field"},[_c('isd-code',{attrs:{"data-segment-id":_vm.dataSegmentId,"field":{
                        association: 'countries',
                        type: 'isd-code',
                        isLocked: true,
                        isRequired: _vm.field.isRequired,
                        label: 'Dialing code',
                        placeholder: 'Dialing code',
                        options: [],
                        key: 'contactInfo.isdCode',
                    },"text-field":"isdCodeTitle","value-field":"isdCode","multiple":false,"name":"Dialing Code"}})],1),_c('div',{staticClass:"col-md-7"},[_c('b-form-input',{attrs:{"type":"number","required":"","autocomplete":"no","placeholder":_vm.field.placeholder}})],1)])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }